<app-breadcrumb [title]="'Gestión de Planes' " [items]="['Mantenimiento']" [active_item]="'Listado de Planes de mantenimiento'">
</app-breadcrumb>
  <div class="container-fluid py-4">

    <!-- Encabezado -->
    <div class="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4">
      <div>
        <h4 class="fw-bold mb-1">
          <i class="bi bi-card-checklist text-primary"></i>
          Planes de Mantenimientos
        </h4>
        <p class="text-secondary mb-0">
          {{ totalActivos }} activos de {{ planes.length }} en total
        </p>
      </div>

      <button class="btn btn-primary" (click)="nuevoPlan()">
        <i class="bi bi-plus-circle"></i> Nuevo plan
      </button>
    </div>
    <div class="filters-card">

    <!-- Buscador: la acción más usada, con más espacio y protagonismo -->
    <div class="search-row">
      <div class="search-input">
        <i class="icofont icofont-search"></i>
        <input type="text" placeholder="Buscar por código, nombre o marca..."
              [(ngModel)]="textoBusqueda" (ngModelChange)="resetearPaginacion()">
        <i class="icofont icofont-close clear-icon" *ngIf="textoBusqueda"
          (click)="textoBusqueda=''; resetearPaginacion()"></i>
      </div>

      <div class="results-count">
        <i class="icofont icofont-check"></i>
        {{ planesFiltrados.length }} {{ planesFiltrados.length === 1 ? 'plan' : 'planes' }}
      </div>
    </div>

    <!-- Filtros -->
    <div class="filter-row">

      <div class="filter-field">
        <label><i class="icofont icofont-car"></i> Tipo Vehículo</label>
        <ng-select [items]="clasesDisponibles" [(ngModel)]="filtroClase"
                  [searchable]="true" [clearable]="true" placeholder="Todas"
                  (change)="resetearPaginacion()">
        </ng-select>
      </div>

  
          <div class="filter-field">
        <label><i class="icofont icofont-ui-battery"></i> Tipo Combustible</label>
        <ng-select [items]="combustiblesDisponibles" [(ngModel)]="filtroCombustible"
                  [searchable]="true" [clearable]="true" placeholder="Todos"
                  (change)="resetearPaginacion()">
        </ng-select>
      </div>

      <div class="filter-field filter-field-status">
        <label><i class="icofont icofont-toggle-on"></i> Estado del Plan</label>
        <div class="status-toggle">
          <button type="button" [class.active]="filtroEstado === ''"
                  (click)="filtroEstado=''; resetearPaginacion()">Todos</button>
          <button type="button" [class.active]="filtroEstado === 'activo'"
                  (click)="filtroEstado='activo'; resetearPaginacion()">Activos</button>
          <button type="button" [class.active]="filtroEstado === 'inactivo'"
                  (click)="filtroEstado='inactivo'; resetearPaginacion()">Inactivos</button>
        </div>
      </div>

    </div>

    <!-- Chips de filtros activos -->
    <!-- chips de filtros activos: feedback de qué está filtrado sin tener que mirar los selects -->
      <div class="active-filters mt-3" *ngIf="filtroClase || filtroCombustible || filtroEstado || textoBusqueda">
        <span class="filter-chip" *ngIf="textoBusqueda">
          "{{ textoBusqueda }}" <i class="fa fa-close" (click)="textoBusqueda=''; resetearPaginacion()"></i>
        </span>
        <span class="filter-chip" *ngIf="filtroClase">
          {{ filtroClase }} <i class="fa fa-close" (click)="filtroClase=''; resetearPaginacion()"></i>
        </span>
        <span class="filter-chip" *ngIf="filtroCombustible">
          {{ filtroCombustible }} <i class="fa fa-close" (click)="filtroCombustible=''; resetearPaginacion()"></i>
        </span>
        <span class="filter-chip" *ngIf="filtroEstado">
          {{ filtroEstado === 'activo' ? 'Activos' : 'Inactivos' }}
          <i class="fa fa-close" (click)="filtroEstado=''; resetearPaginacion()"></i>
        </span>
        <button class="clear-all" (click)="limpiarFiltros()">Limpiar todo</button>
      </div>

  </div>



    <!-- Tabla -->
    <div class="card border-0 shadow-sm rounded-4">
      <div class="table-responsive">
        <table class="table table-plans align-middle mb-0">
          <thead>
            <tr>
              <th>Código</th>           
              <th>Tipo Vehículo</th>
              <th>Marca</th>
              <th>Tipo Combustible</th>
              <th>Modelos</th>
              <th>Cilindrajes</th>        
              <th class="text-center">Estado</th>
              <th class="text-center">Acciones</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let plan of planesPaginados" [class.row-inactive]="!plan.activo">
              <td>
                <div class="d-flex align-items-center gap-3">
                  <div class="plan-icon" [class.plan-icon-inactive]="!plan.activo">
                    <i class="fa fa-wrench"></i>
                  </div>
                  <div>
                  
                  <div class="plan-code">{{ plan.codigo }}</div>
                  <div class="fw-semibold text-dark">{{ plan.nombre }}</div>
                  </div>
                </div>
              </td>
                
                  <td>
                <div class="vehicle-cell">
                  {{ plan.clase }}
                  
                  
                </div>
              </td>
              <td>
                <div class="vehicle-vehicle">
                  <span>

                    {{ plan.marca }}
                  </span>

                </div>
              </td>
              <td>
                  <span><i class="icofont icofont-check"></i> {{ plan.combustible }}</span>
              </td>
              <td>
                <div class="scope-cell">
                  <span class="scope-chip" [class.scope-open]="plan.modelos === 'Todos los modelos'">
                    <i class="bi" [class.bi-unlock-fill]="plan.modelos === 'Todos los modelos'"
                                  [class.bi-funnel-fill]="plan.modelos !== 'Todos los modelos'"></i>
                    {{ plan.modelos }}
                  </span>
                
                </div>
              </td>
              <td>
                <div class="scope-cell">
                
                  <span class="scope-chip" [class.scope-open]="plan.cilindrajes === 'Todos los cilindrajes'">
                    <i class="bi" [class.bi-unlock-fill]="plan.cilindrajes === 'Todos los cilindrajes'"
                                  [class.bi-funnel-fill]="plan.cilindrajes !== 'Todos los cilindrajes'"></i>
                    {{ plan.cilindrajes }}
                  </span>
                </div>
              </td>

              

              <td class="text-center">
                <span class="status-pill" [class.status-off]="!plan.activo">
                  <span class="dot"></span>
                  {{ plan.activo ? 'Activo' : 'Inactivo' }}
                </span>
              </td>
              <td>
                  <div class="acciones-row">

                    
                      <button type="button" class="btn btn-sm btn-outline-primary btn-rounded" [disabled]="!plan.activo"
                          [title]="plan.activo ? 'Ver actividades' : 'El plan está inactivo'" (click)="verActividades(plan)">
                          <i class="icofont icofont-fix-tools" style="font-size:.85rem;"></i>
                      </button>
                        <button type="button" 
                      *ngIf="plan.activo" 
                      class="btn btn-sm btn-outline-warning btn-rounded" 
                      title="Programar mantenimientos" 
                       [routerLink]="['/mantenimientos/programar-mantenimientos', plan.id]">
                          <i class="icofont icofont-check-circled"></i>
                      </button>
                      <button type="button" class="btn btn-sm btn-outline-primary btn-rounded" title="Editar"
                        [routerLink]="['/mantenimientos/crear-plan-mantenimientos/editar', plan.id]">
                      
                        <i class="icofont icofont-edit"></i>
                      </button>
                      <button type="button" *ngIf="!plan.activo" class="btn btn-sm btn-outline-success btn-rounded" title="Activar"
                          (click)="activarDesactivarPlan(plan, true)">
                          <i class="icofont icofont-check-circled"></i>
                      </button>
                      <button type="button" 
                      *ngIf="plan.activo" 
                      class="btn btn-sm btn-outline-danger  
                      btn-rounded" 
                      title="Eliminar" 
                      (click)="activarDesactivarPlan(plan, false)">
                          <i class="icofont icofont-trash"></i>
                      </button>
                     
                  </div>
              </td>
            <!--  <td class="text-end">

                <div class="d-inline-flex gap-2">
                  <button class="icon-btn" title="Ver actividades" (click)="verActividades(plan)">
                    <i class="icofont icofont-refresh"></i>
                  </button>
                  <button class="icon-btn" title="Editar plan" (click)="editarPlan(plan)">
                    <i class="icofont icofont-edit-alt"></i>
                  </button>
              <button class="icon-btn" [class.icon-btn-warn]="plan.activo" [class.icon-btn-success]="!plan.activo"
                  [title]="plan.activo ? 'Inactivar plan' : 'Activar plan'" (click)="pedirConfirmacionEstado(plan)">
                  <i class="icofont" [class.icofont-not-allowed]="plan.activo" [class.icofont-check-circled]="!plan.activo"></i>
              </button>
                </div>
              </td> -->
            </tr>

            <!-- estado vacío -->
            <tr *ngIf="!cargando && planesPaginados.length === 0">
              <td colspan="8" class="text-center py-5">
                <div class="empty-state">
                  <i class="icofont icofont-inbox"></i>
                  <p class="mb-1 fw-semibold">No se encontraron planes</p>
                  <p class="text-secondary mb-0 small">Ajusta los filtros o crea un nuevo plan de mantenimiento.</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- pie de la card, después de </table> -->
  <div class="table-footer" *ngIf="planesFiltrados.length > 0">

    <div class="d-flex align-items-center gap-2">
      <span class="text-secondary small">Mostrando {{ rangoMostrado }}</span>

  <select class="form-select form-select-sm items-select"
          [(ngModel)]="itemsPorPagina" (ngModelChange)="cambiarItemsPorPagina()">
    <option *ngFor="let n of opcionesItemsPorPagina" [ngValue]="n">{{ n }} / página</option>
  </select>
    </div>

    <nav aria-label="Paginación de planes">
      <ul class="pagination pagination-sm mb-0">
        <li class="page-item" [class.disabled]="paginaActual === 1">
          <button class="page-link" (click)="paginaAnterior()">
            <i class="icofont icofont-rounded-left"></i>
          </button>
        </li>

        <li class="page-item" *ngFor="let p of paginasVisibles"
            [class.active]="p === paginaActual" [class.disabled]="p === '...'">
          <button class="page-link" (click)="irAPagina(p)">{{ p }}</button>
        </li>

        <li class="page-item" [class.disabled]="paginaActual === totalPaginas">
          <button class="page-link" (click)="paginaSiguiente()">
            <i class="icofont icofont-rounded-right"></i>
          </button>
        </li>
      </ul>
    </nav>

  </div>
      </div>
    </div>

  </div>

<!-- Modal de confirmación: activar / inactivar -->
<div class="confirm-overlay" *ngIf="planPendiente">
  <div class="confirm-box">
    <div class="confirm-icon" [class.confirm-warn]="planPendiente.activo" [class.confirm-success]="!planPendiente.activo">
      <i class="bi" [class.bi-exclamation-triangle-fill]="planPendiente.activo" [class.bi-check-circle-fill]="!planPendiente.activo"></i>
    </div>

    <h6 class="fw-bold mb-2">
      {{ planPendiente.activo ? 'Inactivar plan' : 'Activar plan' }}
    </h6>

    <p class="text-secondary mb-4">
      <ng-container *ngIf="planPendiente.activo; else activarTexto">
        El plan <b>{{ planPendiente.nombre }}</b> dejará de generarse en nuevas órdenes de trabajo.
        Los vehículos que ya lo tienen asignado no se ven afectados.
      </ng-container>
      <ng-template #activarTexto>
        El plan <b>{{ planPendiente.nombre }}</b> volverá a estar disponible para asignarse a órdenes de trabajo.
      </ng-template>
    </p>

    <div class="d-flex justify-content-end gap-2">
      <button class="btn btn-outline-secondary" (click)="cancelarConfirmacion()">Cancelar</button>
      <button class="btn" [class.btn-danger]="planPendiente.activo" [class.btn-success]="!planPendiente.activo"
              (click)="confirmarCambioEstado()">
        {{ planPendiente.activo ? 'Sí, inactivar' : 'Sí, activar' }}
      </button>
    </div>
  </div>
</div>